import { render, staticRenderFns } from "./PrepareYourDocument.vue?vue&type=template&id=5106cb4c&scoped=true&"
import script from "./PrepareYourDocument.vue?vue&type=script&lang=js&"
export * from "./PrepareYourDocument.vue?vue&type=script&lang=js&"
import style0 from "./PrepareYourDocument.vue?vue&type=style&index=0&id=5106cb4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5106cb4c",
  null
  
)

export default component.exports